import { TradeStatusEnum, type Trade } from '@talos/kyoko';

export function isCustomerTradeCancellable(trade: Trade): boolean {
  return trade.isOrderIDCustomerOrderID && !trade.isManualBookedTrade && trade.TradeStatus !== TradeStatusEnum.Canceled;
}
